// What the Telefon fields of the contact page take while typing (Validator.ts rules alongside).
/** one Telefon field (saved phone): the whole number, always "+" first and digits only (rule `phone`: + and up to 19 digits) */
export const toWholeNumber = (value) => `+${String(value ?? '').replace(/\D/g, '').slice(0, 19)}`;
/** Vorwahl / Telefonnummer next to the country code (no saved phone): digits only, cut at the rule's maximum */
export const toDigits = (value, max) => String(value ?? '').replace(/\D/g, '').slice(0, max);
